<template>
  <div data-component="Metrics">
    <div class="metrics-container">
      <header class="metrics-header">
        <h1>Métriques</h1>
        <button @click="refreshData" class="refresh-button" :disabled="loading">
          <i class="icon-refresh" :class="{ spinning: loading }"></i>
          Actualiser
        </button>
      </header>
      
      <div v-if="loading" class="loading">
        Chargement des métriques...
      </div>
      
      <div v-else class="metrics-content">
        <div class="metrics-grid">
          <div class="metric-card">
            <h3>Visites totales</h3>
            <div class="metric-value">{{ metrics.totalVisits }}</div>
            <div class="metric-change" :class="getChangeClass(metrics.visitsChange)">
              {{ formatChange(metrics.visitsChange) }}
            </div>
          </div>
          
          <div class="metric-card">
            <h3>Lots traités</h3>
            <div class="metric-value">{{ metrics.processedLots }}</div>
            <div class="metric-change" :class="getChangeClass(metrics.lotsChange)">
              {{ formatChange(metrics.lotsChange) }}
            </div>
          </div>
          
          <div class="metric-card">
            <h3>Temps moyen</h3>
            <div class="metric-value">{{ metrics.averageTime }}min</div>
            <div class="metric-change" :class="getChangeClass(metrics.timeChange)">
              {{ formatChange(metrics.timeChange) }}
            </div>
          </div>
          
          <div class="metric-card">
            <h3>Taux de completion</h3>
            <div class="metric-value">{{ metrics.completionRate }}%</div>
            <div class="metric-change" :class="getChangeClass(metrics.completionChange)">
              {{ formatChange(metrics.completionChange) }}
            </div>
          </div>
        </div>
        
        <div class="charts-section">
          <div class="chart-container">
            <h3>Évolution des visites</h3>
            <div class="chart-placeholder">
              <p>Graphique des visites par jour</p>
              <!-- Ici sera intégré un graphique -->
            </div>
          </div>
          
          <div class="chart-container">
            <h3>Répartition par équipe</h3>
            <div class="chart-placeholder">
              <p>Graphique en secteurs par équipe</p>
              <!-- Ici sera intégré un graphique -->
            </div>
          </div>
        </div>
        
        <div class="team-metrics">
          <h3>Métriques par équipe</h3>
          <div class="team-list">
            <div v-for="team in teamMetrics" :key="team.id" class="team-item">
              <div class="team-info">
                <h4>{{ team.name }}</h4>
                <div class="team-stats">
                  <span>{{ team.visits }} visites</span>
                  <span>{{ team.lots }} lots</span>
                  <span>{{ team.avgTime }}min/visite</span>
                </div>
              </div>
              <div class="team-progress">
                <div class="progress-bar">
                  <div 
                    class="progress-fill" 
                    :style="{ width: team.completion + '%' }"
                  ></div>
                </div>
                <span class="progress-text">{{ team.completion }}%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'MetricsView',
  data() {
    return {
      loading: false,
      metrics: {
        totalVisits: 0,
        processedLots: 0,
        averageTime: 0,
        completionRate: 0,
        visitsChange: 0,
        lotsChange: 0,
        timeChange: 0,
        completionChange: 0
      },
      teamMetrics: []
    }
  },
  computed: {
    ...mapState('metrics', ['currentMetrics'])
  },
  async mounted() {
    await this.loadMetrics()
  },
  methods: {
    ...mapActions('metrics', ['fetchMetrics']),
    
    async loadMetrics() {
      this.loading = true
      try {
        // Simuler le chargement des métriques
        await new Promise(resolve => setTimeout(resolve, 1000))
        
        this.metrics = {
          totalVisits: 1247,
          processedLots: 892,
          averageTime: 45,
          completionRate: 87,
          visitsChange: 12.5,
          lotsChange: -3.2,
          timeChange: -8.1,
          completionChange: 5.3
        }
        
        this.teamMetrics = [
          {
            id: '1',
            name: 'Équipe A',
            visits: 456,
            lots: 324,
            avgTime: 42,
            completion: 92
          },
          {
            id: '2',
            name: 'Équipe B',
            visits: 389,
            lots: 278,
            avgTime: 48,
            completion: 85
          },
          {
            id: '3',
            name: 'Équipe C',
            visits: 402,
            lots: 290,
            avgTime: 46,
            completion: 88
          }
        ]
        
      } catch (error) {
        console.error('Erreur lors du chargement des métriques:', error)
      } finally {
        this.loading = false
      }
    },
    
    async refreshData() {
      await this.loadMetrics()
    },
    
    getChangeClass(change) {
      if (change > 0) return 'positive'
      if (change < 0) return 'negative'
      return 'neutral'
    },
    
    formatChange(change) {
      const sign = change > 0 ? '+' : ''
      return `${sign}${change.toFixed(1)}%`
    }
  }
}
</script>

<style lang="scss" scoped>
@import './Metrics.scss';
</style>
